import { renderToStaticMarkup } from "react-dom/server";
import QRCode from "react-qr-code";
import type { CheckInPrintCode } from "../api/dto/CheckInPrintCode";
import { formatDateTime } from "./formatTime";

const escapeHtml = (text: string) =>
  text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/**
 * Fills a window opened with `window.open` (which has to happen directly in the click handler, or the browser blocks
 * it) with a page to print: the QR of the printed code, what it is for and until when it works.
 */
export const printCheckInCode = (
  printWindow: Window,
  projectName: string,
  printCode: CheckInPrintCode,
) => {
  const qr = renderToStaticMarkup(<QRCode value={printCode.qrPayload} size={320} />);
  const code = `${printCode.code.slice(0, 3)} ${printCode.code.slice(3)}`;
  const title = `Inchecken bij ${escapeHtml(projectName)}`;

  printWindow.document.open();
  printWindow.document.write(`<!DOCTYPE html>
<html lang="nl">
<head>
  <meta charset="utf-8">
  <title>${title}</title>
  <style>
    body { font-family: sans-serif; text-align: center; margin: 3rem 2rem; color: #0f172a; }
    h1 { font-size: 2rem; margin: 0 0 .5rem; }
    p { font-size: 1.1rem; margin: .5rem 0; }
    .qr { margin: 2rem auto; padding: 1rem; display: inline-block; border: 1px solid #cbd5e1; border-radius: .5rem; }
    .code { font-family: monospace; font-size: 2.5rem; font-weight: bold; letter-spacing: .2em; }
    .valid { margin-top: 2rem; font-weight: bold; }
  </style>
</head>
<body>
  <h1>${title}</h1>
  <p>Scan deze QR-code met de Veilig Hijsen app om in te checken.</p>
  <div class="qr">${qr}</div>
  <p>Lukt scannen niet? Voer deze code in:</p>
  <p class="code">${code}</p>
  <p class="valid">Geldig tot ${escapeHtml(formatDateTime(printCode.expiresAt))}</p>
</body>
</html>`);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
